import Swal from 'sweetalert2';

export const Alert = Swal.mixin({
  background: '#0f1520',
  color: '#e8edf5',
  confirmButtonColor: '#3ddc84',
  cancelButtonColor: '#374258',
  customClass: {
    popup: 'fp-alert-popup',
    title: 'fp-alert-title',
    htmlContainer: 'fp-alert-body',
    confirmButton: 'fp-alert-btn-confirm',
    cancelButton: 'fp-alert-btn-cancel',
  },
  backdrop: 'rgba(8,12,16,0.85)',
});

export const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  background: '#0f1520',
  color: '#e8edf5',
  customClass: {
    popup: 'fp-toast-popup',
    timerProgressBar: 'fp-toast-progress',
  }
});

export const showSuccess = (message: string) => Toast.fire({ icon: 'success', title: message });
export const showError = (message: string) => Toast.fire({ icon: 'error', title: message });
export const showWarning = (message: string) => Toast.fire({ icon: 'warning', title: message });
export const showInfo = (message: string) => Toast.fire({ icon: 'info', title: message });
export const confirmAction = (title: string, text: string) =>
  Alert.fire({ title, text, icon: 'warning', showCancelButton: true, confirmButtonText: 'Yes, proceed' });
